import { REGISTRATION_TYPE } from "@/constants/config";
import { preparePackageSuggestionBasedOnType } from "@/helpers";

export default function storePackageType({ store })
{
    const type = store.getters['company/registrationType'];

    // it definitely coming from Enston
    if (type && REGISTRATION_TYPE.TYPES.includes(type))
    {
        store.commit('cart/CLEAR');
        store.commit('company/CLEAR');
        store.commit('company/SET_REGISTRATION_TYPE', type);

        preparePackageSuggestionBasedOnType();
    }

    return false;
}
